export const PageHeader =
  'top-0 z-10 w-full h-[72px] flex shrink-0 justify-between text-[21px] border-b-[1px] border-b-[#E7EAEC] dark:border-b-[#192932] font-medium bg-white dark:bg-[#0B1922] text-gray-900 dark:text-gray-100';

export const PageHeaderTitle =
  'border-r-[1px] border-r-[#E7EAEC] dark:border-r-[#192932] flex items-center justify-center align-center pr-4';

export const PageHeaderActions = 'flex justify-center align-center gap-4';
export const PageActionItem = 'p-4';
